import { IconProps } from "../../utils/global-types/global-types";

const RedirectIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.833 1.75h-1.75A2.333 2.333 0 0 0 1.75 4.083v5.834a2.333 2.333 0 0 0 2.333 2.333h5.834a2.333 2.333 0 0 0 2.333-2.333v-1.75h-1.167v1.75c0 .644-.522 1.166-1.166 1.166H4.083a1.166 1.166 0 0 1-1.166-1.166V4.083c0-.644.522-1.166 1.166-1.166h1.75zm4.426 1.167-3.671 3.67.824.825 3.671-3.67v2.091h1.167v-3.5a.584.584 0 0 0-.583-.583h-3.5v1.167z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default RedirectIcon;
